module.exports = __webpack_public_path__ + "static/Periodic-Table_high_989x640.552e1d44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Periodic-Table_high_989x640.jpg
// module id = 601
// module chunks = 1520471504850